
<template>
  <div class="ph-compare-page">
    <top-bar ref="topBarRef" title="产品对比"></top-bar>
    <div class="ph-compare-category-page">
      <div class="page-title">对比分类</div>
      <div class="ph-compare-category-list">
        <div class="compare-category-item" v-for="cate in category" @click="toProductList(cate.id)" v-if="cate.cn_name">
          <div class="compare-category-image">
            <img :src="cate.image" alt="">
          </div>
          <div class="category-title">
            {{ cate.cn_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import topBar from "./components/top-bar.vue";

export default {
  components: {topBar},
  data() {
    return {
      category: []
    }
  },
  computed: {
    ...mapState(['compare'])
  },
  methods: {
    getCategory() {
      this.$api.get_compare_category().then(res => {
        this.category = res.data
      })
    },
    toProductList(id){
      if(this.compare.category_id != id){
        this.$store.commit('saveCompareProducts', [])
      }
      this.$store.commit('setCompareCategoryId', id)

      this.$router.push('/ph/compare/list')
    },
  },
  mounted() {
    this.getCategory()
  }
}
</script>

<style>
@import "../../style/compare.css";

</style>

<style scoped>

.ph-compare-category-page {
  background-color: #f2f2f2;
  padding: 0 .3rem .8rem .3rem;
}
.ph-compare-category-page .page-title {
  font-size: .3rem;
  padding-top: .3rem;
}
.ph-compare-category-page .ph-compare-category-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: .2rem;
}
.ph-compare-category-page .ph-compare-category-list .compare-category-item{
  width: 2.495rem;
  margin-top: .3rem;
  background-color: #ffffff;
  padding: .3rem .4rem;
  border-radius: 20px;
  overflow: hidden;
}
.ph-compare-category-page .ph-compare-category-list .compare-category-item:first-child,
.ph-compare-category-page .ph-compare-category-list .compare-category-item:nth-child(2) {
  margin-top: 0;
}
.ph-compare-category-page .ph-compare-category-list .compare-category-item:nth-child(even) {
  margin-left: .3rem;
}
.ph-compare-category-page .ph-compare-category-list .compare-category-item .compare-category-image{
  width: 2.495rem;
}
.ph-compare-category-page .ph-compare-category-list .compare-category-item .compare-category-image img {
  width: 100%;
  display: block;
}

.ph-compare-category-page .ph-compare-category-list .compare-category-item .category-title {
  font-size: .24rem;
  text-align: center;
}
</style>